import { Component, OnInit, ViewChild  } from '@angular/core';
import { Apollo, QueryRef, gql } from 'apollo-angular';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { FormBuilder,FormGroup, FormControl, Validators} from '@angular/forms';
import moment from 'moment';
import { MatDialog } from "@angular/material/dialog";

import { HttpClient, HttpHeaders } from '@angular/common/http'; 

//SERVICES
import { ContratistaService } from 'src/app/services/contratista.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { DetalleService } from 'src/app/services/detalle.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';
import { LoginService } from 'src/app/services/login.service';

//componentes
import { ComentariosComponent } from 'src/app/components/portal-contratista/comentarios/comentarios.component';
import { UploadDocumentosService } from 'src/app/services/upload-documentos.service';

@Component({
  selector: 'app-doc-propia',
  templateUrl: './doc-propia.component.html',
  styleUrls: ['./doc-propia.component.scss']
})



export class DocPropiaComponent implements OnInit {
  //UPLOAD
   public files: NgxFileDropEntry[] = [];
   public documentos: any[] = []
  public documento: any;
  public headers: any
  public relativePath: any
  public e: any
  //TABLA Y FORM
   public documentosContratistas: any[] = []
    public documentosCaducados: any[] = []
    public loading?: Boolean
    public tableColumns?: String[]
    public title?: String
    public dataSource?: any
    public filterValue?: string
    datosDocumento: any={};
    datosHacienda: any={};
    public date: any
    public otherDate: any
    public fecha: any
    public fileName: any
    public comentarios?: any[] = []
    public datepicker: any
    public datepicker3: any
    public contratista: any
    id:any
    data: any
    seguridadSocial: any
    hacienda: any
    documentosC: any
    token: any
    datas:any
    url: any
    contratistaLog: any
    idContratista: any
    nameDocumento1:any
    nameDocumento2:any
    docSeguridad: any
    docHacienda: any
    userLog:any


    @ViewChild(MatSort) sort?: MatSort;

  

  


  constructor(private apollo: Apollo,private contratistaService: ContratistaService, private documentoService: DocumentoService, 
    private formBuilder: FormBuilder,
    private detalleService: DetalleService, public dialog: MatDialog, 
    private confirmacionService: ConfirmacionService, private loginservice: LoginService,
    private http: HttpClient,
    private loginService: LoginService, private uploadService: UploadDocumentosService) {
    this.buildForm();
    this.tableColumns = [ 'nombre',  'indicador', 'fechaEmision', 'fechaCaducidad', 'acciones']
    this.date= new Date()
    this.userLog = loginService.getUserData()
   }

  ngOnInit() {
    this.contratistaLog = this.loginService.getUserData()
    this.idContratista = this.contratistaLog.contratista.id
    this.getContratistaById() 
    this.getDocumentos()
    this.token = this.loginservice.getUserToken()
  }

  dropped1(files: any){
    this.uploadService.dropped(files).subscribe((res:any)=>{
      this.nameDocumento1 = res[0].name;
      this.url = res[0].url
    })
    
   }

   dropped2(files: any){
    this.uploadService.dropped(files).subscribe((res:any)=>{
      this.nameDocumento2 = res[0].name;
      this.url = res[0].url
    })
    
   }

   public fileOver(e:any){
    console.log(event); 
  }

  public fileLeave(e:any){
     console.log(event);
  }


   getContratistaById(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistaById(),
      variables: {
        "id": this.idContratista
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
      this.data= data
      this.contratista= this.data.contratista
      this.seguridadSocial= this.contratista.seguridadSocial
      this.hacienda= this.contratista.hacienda
    
      })
  } 

  private buildForm(){
    this.datosDocumento = this.formBuilder.group({
      nombre: [''],
      fechaValidez: ['',[Validators.required]],
      fechaCaducidad: ['',[Validators.required]],
    });
    this.datosHacienda = this.formBuilder.group({
      nombre: ['' ],
      fechaValidez: ['',[Validators.required]],
      fechaCaducidad: ['', [Validators.required]],
    });
  }

  getDate(fecha: any){
    this.date = moment(new Date(fecha)).format('Y-MM-DD')
  }

  getOtherDate(fecha: any){
    this.otherDate = moment(new Date(fecha)).format('Y-MM-DD')
  }
  getFileName() {
    this.files.forEach(file => {
      this.fileName = file})
  }


  addDocumento(){
    this.getDate(this.datosDocumento.value.fechaValidez)
    this.getOtherDate(this.datosDocumento.value.fechaCaducidad)
    this.getFileName()
    this.apollo.mutate<any>({
      mutation: this.documentoService.addDocumento(),
      variables: {
        "input": {
          "data": {
            "contratista": this.idContratista,
            "nombre": this.nameDocumento1,
            "fechaValidez": this.date,
            "fechaCaducidad": this.otherDate,
            "obligatorio": true,
            "seguridadSocial": true,
            "comentariosNuevos": true,
            "solicitudReemplazo": false,
            "tipo": "seguridadSocialPendiente",
            "url": this.url,
            "validado": false,
            "nombreArchivo": 'seguridadSocial',
            "subidoPor": this.userLog.id
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
       this.updateContratistaSeguridadSocial()
        location.reload()
      
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

 addHacienda(){
    this.getDate(this.datosHacienda.value.fechaValidez)
    this.getOtherDate(this.datosHacienda.value.fechaCaducidad)
    this.getFileName()
    this.apollo.mutate<any>({
      mutation: this.documentoService.addDocumento(),
      variables: {
        "input": {
          "data": {
            "contratista": this.idContratista,
            "nombre": this.nameDocumento2,
            "fechaValidez": this.date,
            "fechaCaducidad": this.otherDate,
            "obligatorio": true,
            "hacienda": true,
            "comentariosNuevos": true,
            "tipo": "haciendaPendiente",
            "url": this.url,
            "validado": false,
            "nombreArchivo": 'hacienda',
            "subidoPor": this.userLog.id
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
    this.documentos.push(data.createDocumento)
    this.updateContratistaHacienda()
    location.reload()
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  updateContratistaSeguridadSocial(){
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.idContratista
          },
          "data": {
            "seguridadSocial": true,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }
  updateContratistaNuevoSeguridadSocial(){
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.idContratista
          },
          "data": {
            "seguridadSocial": true,
            "nuevoSeguridadSocial":true
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }


   updateContratistaHacienda(){
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.idContratista
          },
          "data": {
            "hacienda": true,
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  updateContratistaNuevoHacienda(){
    this.apollo.mutate({
      mutation: this.contratistaService.updateContratista(),
      variables: {
        "input": {
          "where": {
            "id": this.idContratista
          },
          "data": {
            "hacienda": true,
            "nuevoHacienda":true
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }




 getDocumentos(){
    this.apollo.watchQuery<any>({
      query: this.documentoService.getDocumentosByContratista(),
      fetchPolicy: 'no-cache',
      variables: {
        "id": this.idContratista
        
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        this.data = data
        this.documentosC = this.data.contratista.documentos
        this.documentosC.map((documento: any) => {
          console.log(documento)
          if(documento.tipo != 'haciendaInactivo' && documento.tipo != 'seguridadSocialInactivo'  ) {
            this.documentos.push(documento)
            this.docSeguridad = this.documentos.filter((doc: any)=> doc.tipo == 'seguridadSocialActivo' ||  doc.tipo == 'seguridadSocialEnEspera' ||  doc.tipo == 'seguridadSocialActivoEnEspera' ||  doc.tipo == 'seguridadSocialPendiente')
            console.log(this.docSeguridad);
            this.docHacienda = this.documentos.filter((doc: any)=> doc.tipo == 'haciendaActivo' ||  doc.tipo == 'haciendaEnEspera' || doc.tipo == 'haciendaActivoEnEspera' || doc.tipo == 'haciendaPendiente')
            console.log(this.docHacienda);
          }
        })
        this.setIndicadores()
        this.setDataTableOptions(this.documentos) 
      })
  } 

  setDataTableOptions(doc: any){
    this.dataSource = new MatTableDataSource(doc)  
  }
  
  setComentariosLeidos(id: string){
    this.documentoService.setComentariosLeidos(id)
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data, errors)
      }, (error) => {
        console.log(error)
      })
  }

  setIndicadores(){
    this.documentos.map((documento: any) => {
      if(documento?.validado === true) {
        this.setDocumentoProximoCaduca()
        this.setDocumentoCaducado()
        this.setDocumentoEnFecha()
      }
    })
  }

  setDocumentoProximoCaduca(){
    this.documentos.map((documento: any) => {
      if(documento?.fechaCaducidad <= this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate()) {
        this.updateDocumentoToProximoCaduca(documento?.id)
      }
    })
  }

  updateDocumentoToProximoCaduca(id: string){
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "proximoCaduca": true,
            "caducado": false,
            "enFecha": false
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

    setDocumentoCaducado(){
    this.documentos.map((documento: any) => {
      if(documento.fechaCaducidad <= this.documentoService.getActualDate()) {
        this.updateDocumentoToCaducado(documento.id)
      }
    })
  }

   updateDocumentoToCaducado(id: string){
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": true,
            "proximoCaduca": false,
            "enFecha":false
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

  setDocumentoEnFecha(){
    this.documentos.map((documento: any) => {
      if(documento?.fechaCaducidad > this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFecha(documento?.id)
      }
    })
  }

   updateDocumentoToEnFecha(id: string){
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": false,
            "proximoCaduca": false,
            "enFecha":true
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }



  openValidation(id: string){
    const options= {
      id: id,
    }
    this.detalleService.openTest(options, ComentariosComponent);
  }

  
  deleteDocumentoById(id: String){
    this.apollo.mutate({
      mutation: this.documentoService.deleteDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({data}) => {
        console.log('BORRADO', data)
      }, (error) => {
        console.log(error)
      })
  }

  handleClick(id: String){
    const options = {
      text: '¿Está seguro de eliminar este registro?', 
      cancelText: 'Cancelar',
      confirmText: 'Eliminar'
    };
    this.confirmacionService.open(options);
      
    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteDocumentoById(id)
        location.reload()
      }
      });
  }

}
